import { Guid } from '@ups/xplat/core';
import { ManufacturerItem } from './manufacturerItem';
import { VendorManufacturerItemDto } from './vendorManufacturerItemDto';

export class ItemDTO {
  hasSerialNumber: boolean;
  hasTethering: boolean;
  isActive: boolean;
  itemGroupId: string;
  itemGroupName: string;
  itemId: string;
  itemName: string;
  itemType: string;
  itemTypeId: string;
  manufacturerItems: ManufacturerItem[];
  manufacturerPartNumber?: string;
  modifiedBy: string | null;
  modifiedDate: string | null;
  partNumber: string;
  preferredManufacturerItemId?: string;
  preferredManufacturer?: string;
  preferredVendor?: string;
  unitOfMeasureId: string;
  unitPrice: number;
  vendorId?: string;
  vendorManufacturerItem: VendorManufacturerItemDto[];
  itemInstructions?: string;

  constructor() {
    this.hasSerialNumber = false;
    this.hasTethering = false;
    this.isActive = true;
    this.itemGroupName = '';
    this.itemId = Guid.empty;
    this.itemName = '';
    this.itemTypeId = Guid.empty;
    this.manufacturerItems = [];
    this.manufacturerPartNumber = '';
    this.modifiedBy = null;
    this.modifiedDate = null;
    this.partNumber = '';
    this.preferredManufacturerItemId = '';
    this.preferredManufacturer = '';
    this.preferredVendor = '';
    this.unitPrice = 0;
    this.vendorId = Guid.empty;
    this.vendorManufacturerItem = [];
  }
}
